<template>
	<el-dialog title="回收站" :visible.sync="dialogVisible" width="1000px" :before-close="handleClose" class="collection-depot" :close-on-click-modal="false">
		<div>
			<div class="filter-websit">
				<div class="filter-top">
					<div class="filter-top-content">
						<!-- <el-input placeholder="请输入内容" v-model="inputKey2" class="search-input"></el-input>
						<el-button class="search-btn " @click="searchData"><img src="../../../assets/img/monitoring/guolvshezhi/seach.png" alt=""> 搜 索</el-button> -->
						<el-input placeholder="请输入内容" v-model.trim="inputKey2" class="input-with-select searchinput">
							<el-button slot="append" type="primary" class="thmeBackColor borderColor searchbtn" @click="searchData">
								<!-- <img src="~@/assets/img/monitoring/guolvshezhi/seach.png" alt="" /> -->
								<i class="iconfont iconseach seach-icon"></i>
								搜 索
							</el-button>
						</el-input>
					</div>
				</div>
				<div class="table-div">
					<el-table
						:data="yuqingList"
						style="width:100%;"
						stripe
						border
						max-height="327px"
						:header-cell-style="{ background: '#e7ecf2', color: '#0092f1' }"
					>
						<el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
						<el-table-column prop="title" header-align="left"  label="标题" :show-overflow-tooltip="true" width="283">
							<template slot-scope="scope">
								<div v-html="scope.row.title"></div>
							</template>
						</el-table-column>
						<el-table-column prop="websiteName" header-align="center" align="center" label="网站" width="100" :show-overflow-tooltip="true"></el-table-column>
						<el-table-column prop="pageTime" header-align="center" align="center" label="发表时间" width="154">
							<template slot-scope="scope">
								<div v-html="$moment(scope.row.pageTime).format('YYYY-MM-DD HH:mm')"></div>
							</template>
						</el-table-column>
						<el-table-column prop="deleteTime" header-align="center" align="center" label="删除时间" width="154">
							<template slot-scope="scope">
								<div v-html="scope.row.deleteTime == '' ? '' : $moment(scope.row.deleteTime).format('YYYY-MM-DD HH:mm')"></div>
							</template>
						</el-table-column>
						<el-table-column prop="deleteUserName" header-align="center" align="center" label="删除人"></el-table-column>
						<el-table-column label="操作" :show-overflow-tooltip="false" header-align="center">
							<template slot-scope="scope">
								<el-button @click="reduction(scope.row)" class="add-btn" type="text">
									<!-- <img src="../../../assets/img/global/chehui_03.png" alt="" /> -->
									<i class="iconfont iconfanhui1 hovertext" style="font-size: 20px;color:#666666;vertical-align: middle;"></i>
									还原
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="nodata" style="min-height:283px;" v-if="yuqingList.length == 0">
						<div class="nodataImg">
							<div class="textC ">
								<i class="iconfont iconwushuju wushuju-icon"></i>
								<!-- <img src="../../../assets/img/earlyWarning/wsj_03.png" alt="" /> -->
								</div>
							<div class="textC font14 nodataText">暂无数据！</div>
						</div>
					</div>
				</div>
			</div>
			<div class="page-footer textR">
				<el-row class="flex-center">
					<el-col :span="8" class="total-col textL">
						共
						<span class="total-color">{{ totalPage }}</span>
						页
					</el-col>
					<el-col :span="16" class="textR flexcol">
						<el-pagination
							:current-page="currentPage"
							:total="total"
							@current-change="handlePageNoChange"
							background
							layout="total,prev, pager, next,jumper"
							:pager-count="5"
						></el-pagination>
						<el-button class="go-btn">GO</el-button>
					</el-col>
				</el-row>
			</div>
		</div>
		<closed-prop2 ref="closedProp2"></closed-prop2>
		<warning-prop ref="warningProp2"></warning-prop>
	</el-dialog>
</template>

<script>
import warningApi from '@/api/warning';
export default {
	props: {
		filterName: {
			type: String,
			default: () => '' //过滤网站添加
		},
		filterTitle: {
			type: String,
			default: () => '' //过滤网站添加
		},
		index: {
			type: String,
			default: () => '' //索引
		}
	},
	data() {
		return {
			dialogVisible: false,
			filterType: 'domainName',
			inputKey2: '',
			yuqingList: [],
			total: 1,
			currentPage: 1,
			pageSize: 10,
			totalPage: 0,
			active: {
				borderColor: true,
				textColor: true
			},
			sort: 11
		};
	},
	created() {},
	mounted() {
		// this.searchData();
	},
	methods: {
		show() {
			this.dialogVisible = true;
			this.searchData();
		},
		handleClose(done) {
			this.$parent.getList();
			this.dialogVisible = false;
		},
		reduction(selectedListitem) {
			let _this = this;
			let data = {
				deleted: 0,
				all: 0,
				index: _this.index,
				ids: selectedListitem.id
			};
			warningApi.bulkData(data).then(res => {
				if (res.returnCode === '1001') {
					let index = this.yuqingList.findIndex(item => {
						return item.id === selectedListitem.id;
					});
					_this.yuqingList.splice(index, 1);
					if (_this.yuqingList.length == 0) {
						if (_this.currentPage != 1) {
							_this.currentPage--;
						}
						_this.initData();
					}
					_this.showClosedProp2('还原成功');
				}
			});
		},
		showClosedProp2(tips) {
			this.$refs.closedProp2.show(tips);
		},
		initPage() {},
		searchData: function() {
			let that = this;
			that.currentPage = 1;
			that.initData();
		},
		initData: function() {
			let _this = this;
			_this.dataloading = true;
			let data = {
				pageNo: _this.currentPage,
				pageSize: _this.pageSize,
				key: _this.inputKey2,
				deleted: 1,
				sort: _this.sort
			};
			warningApi.list(data).then(res => {
				_this.dataloading = false;
				if (res.returnCode == '1001') {
					let rst = res.returnData.data;
					if (rst != null && rst.length > 0) {
						rst.forEach(item => {
							item.contentTag = _this.$utils.handleText(item.contentTag);
						});
					}
					_this.yuqingList = rst;
					_this.total = res.returnData.total;
					_this.totalPage = res.returnData.totalPage;
				} else {
					_this.$refs.warningProp2.show('数据异常!');
				}
			});
		},
		handlePageNoChange(pageNo) {
			this.currentPage = pageNo;
			this.initData();
		},
		toggleActive(val) {
			this.queryInfo.type = val;
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		}
	},
	watch: {
		dialogVisible: {
			handler: function(val, oldval) {},
			deep: true //对象内部的属性监听，也叫深度监听
		}
	}
};
</script>

<style lang="less">
.collection-depot {
	.table-div {
		min-height: 327px;
	}
	.el-dialog__body {
		padding: 30px 32px;
	}

	.filter-websit {
		.filter-top {
			.filter-top-content {
				// display: flex;
				// align-items: center;
				// justify-content: space-around;
				text-align: center;
				.searchinput {
					border-radius: 4px;
					&.el-input {
						width: 780px;
						.el-input__prefix {
							top: -3px;
						}
						.el-input__inner {
							border: solid 2px #1a9df2;
							height: 36px;
							.el-input__icon.el-icon-search {
								line-height: 36px !important;
							}
						}
						.searchbtn {
							width: 100px;
							color: #fff;
							border-radius: 0px 4px 4px 0px;
							height: 36px;
							margin: -2px -20px;
							line-height: 9px;
							width: 180px;
							padding: 0px;
							font-size: 16px;
							line-height: 36px;
						}
					}
				}
			}

			.filter-type-select {
				width: 194px;

				.el-input {
					height: 40px;

					.el-input__inner {
					}
				}
			}

			.search-input {
				width: 366px;
				height: 40px;
			}

			.search-btn {
				width: 180px;
				height: 40px;
				background-color: #0092f1;
				border-radius: 4px;
				color: #fff;
				padding: 0px;
			}
		}
	}

	.table-div {
		margin: 20px 0px;
	}
	.nodata {
		border: 1px solid #e3efff;
		border-top: none;
		position: relative;
		// top:54%;
		height: 287px;
		.nodataImg {
			position: absolute;
			top: 40%;
			transform: translate(-50%, -50%);
			left: 50%;
			.nodataText {
				font-family: MicrosoftYaHei;
				font-size: 14px;
				font-weight: normal;
				font-stretch: normal;
				letter-spacing: 1px;
				color: #999999;
			}
			img {
				width: 96px;
			}
		}
	}
	.add-btn {
		width: 100%;
		//height: 30px;
		background-color: transparent;
		border-radius: 4px;
		border: solid 1px transparent;
		color: #666666;
		font-size: 14px;
		padding: 0px;
		//line-height: 30px;

		.img-icon {
			width: 19px;
			height: 19px;
			display: inline-block;
			vertical-align: middle;
			background: url(../../../assets/img/monitoring/guolvshezhi/add-1.png) no-repeat;
			//background-size: 100% 100%;
		}

		&:hover {
			// border: solid 1px #0092f1;
			// color: #0092f1;

			.img-icon {
				background: url(../../../assets/img/monitoring/guolvshezhi/add.png) no-repeat;
				//background-size: 100% 100%;
			}
		}
	}
	.flex-center {
		display: flex;
		align-items: center;
	}

	.total-col {
		font-family: MicrosoftYaHeiLight;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0px;
		color: #4b414e;

		.total-color {
			color: #ff1414;
		}
	}
	.website-control {
		.filter-top-content {
			display: flex;
			align-items: center;
		}

		.batch-add-btn {
			width: 105px;
			height: 35px;
			background-color: #ffffff;
			border-radius: 4px;
			border: solid 1px #666666;
			font-family: MicrosoftYaHei;
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 1px;
			color: #666666;
			padding: 0px;
			line-height: 30px;
		}

		.searchinput {
			&.el-input {
				margin-left: 22px;
				width: 426px;

				.el-input__prefix {
					top: -3px;
				}

				.el-input__inner {
					height: 40px;

					.el-input__icon.el-icon-search {
						line-height: 40px !important;
					}
				}

				.searchbtn {
					width: 100px;
					color: #fff;
					border-radius: 0px 4px 4px 0px;
					height: 40px;
					margin: -2px -20px;
					width: 106px;
					line-height: 9px;
					line-height: 40px;
					padding: 0px;
				}
			}
		}

		.filter-name {
			display: inline-block;
			// width: 80px;
			//height: 28px;
			font-family: MicrosoftYaHei;
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 2px;
			color: #666666;
			padding: 7px 16px;
			border-radius: 20px;
			border: solid 1px transparent;
			// &.active{
			// 	border-color: #0092f1;
			// 	color: #0092f1;
			// }
		}
	}
	.el-table td {
		height:  auto;
	    line-height: normal;
		padding: 8px 0px !important;
		.el-button {
			padding: 0px;
		}
	}
}
</style>
